import {
  PublicClientApplication,
  type PublicClientApplication as IPublicClientApplication,
} from "@azure/msal-browser";
import { internalMsalConfig } from "../config/internal-auth-config";

let clientInstance: IPublicClientApplication | null = null;

const SCOPES = ["openid", "profile", "email"];

export async function getInternalMsalClient(): Promise<PublicClientApplication> {
  if (!clientInstance) {
    console.log("[MSAL Internal] Initializing PublicClientApplication...");
    clientInstance = new PublicClientApplication(internalMsalConfig);
    await clientInstance.initialize();
    console.log("[MSAL Internal] Client initialized successfully");
  }
  return clientInstance;
}

export async function signInWithMicrosoft(): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const client = await getInternalMsalClient();
    const result = await client.loginPopup({
      scopes: SCOPES,
      prompt: "select_account",
    });
    const claims = result.idTokenClaims as Record<string, unknown> | undefined;
    const roles = (claims?.roles as string[]) || [];
    if (!roles.some((r) => ["root", "commercial", "analyst"].includes(r))) {
      await client.logoutPopup();
      return {
        success: false,
        error: "Nenhum papel de administrador atribuído. Entre em contato com o suporte.",
      };
    }
    return { success: true };
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : "Falha na autenticação";
    return { success: false, error: message };
  }
}

export async function signOutMicrosoft(): Promise<void> {
  try {
    const client = await getInternalMsalClient();
    await client.logoutPopup();
  } catch {
    // Continue with local cleanup
  }
}
